import { useTheme } from '@mui/material';

export default function EmbedWebCenterIcon({
  isSelected,
  buttonBgColor = '#fff',
  buttonColor = '#000'
}: {
  isSelected?: boolean;
  buttonBgColor?: string;
  buttonColor?: string;
}) {
  const theme = useTheme();
  return (
    <svg width='252' height='180' viewBox='0 0 252 180' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='251.333' height='180' rx='8' fill='#ECECEC' />
      {isSelected && <rect x='0.5' y='0.5' width='250.333' height='179' rx='7.5' stroke={theme.palette.primary.main} />}
      <path
        d='M22.6662 25.5043C24.2337 25.5043 25.5043 24.2337 25.5043 22.6662C25.5043 21.0988 24.2337 19.8281 22.6662 19.8281C21.0988 19.8281 19.8281 21.0988 19.8281 22.6662C19.8281 24.2337 21.0988 25.5043 22.6662 25.5043Z'
        fill='#EF4444'
      />
      <path
        d='M31.6506 25.5043C33.218 25.5043 34.4887 24.2337 34.4887 22.6662C34.4887 21.0988 33.218 19.8281 31.6506 19.8281C30.0832 19.8281 28.8125 21.0988 28.8125 22.6662C28.8125 24.2337 30.0832 25.5043 31.6506 25.5043Z'
        fill='#FCD34D'
      />
      <path
        d='M40.6272 25.5043C42.1946 25.5043 43.4653 24.2337 43.4653 22.6662C43.4653 21.0988 42.1946 19.8281 40.6272 19.8281C39.0597 19.8281 37.7891 21.0988 37.7891 22.6662C37.7891 24.2337 39.0597 25.5043 40.6272 25.5043Z'
        fill='#83E83F'
      />
      <path
        d='M223.041 45.3281H28.2953C23.619 45.3281 19.8281 48.7541 19.8281 52.9803V81.6759C19.8281 85.9021 23.619 89.3281 28.2953 89.3281H223.041C227.717 89.3281 231.508 85.9021 231.508 81.6759V52.9803C231.508 48.7541 227.717 45.3281 223.041 45.3281Z'
        fill={theme.palette.primary.main}
      />
      <path
        d='M88.8887 95.9375H24.5583C21.9459 95.9375 19.8281 98.0553 19.8281 100.668V100.668C19.8281 103.28 21.9459 105.398 24.5583 105.398H88.8887C91.5011 105.398 93.6188 103.28 93.6188 100.668C93.6188 98.0553 91.5011 95.9375 88.8887 95.9375Z'
        fill={theme.palette.primary.main}
      />
      <rect x='107.492' y='125.227' width='36.3492' height='36.3492' rx='18.1746' fill={buttonBgColor} />
      <path
        d='M125.668 145.066C124.898 145.066 124.247 144.799 123.713 144.266C123.18 143.733 122.914 143.081 122.914 142.312V135.703C122.914 134.933 123.18 134.282 123.713 133.749C124.247 133.216 124.898 132.949 125.668 132.949C126.437 132.949 127.088 133.216 127.622 133.749C128.155 134.282 128.421 134.933 128.421 135.703V142.312C128.421 143.081 128.155 143.733 127.622 144.266C127.088 144.799 126.437 145.066 125.668 145.066ZM124.841 153.051V149.421C123.024 149.213 121.514 148.434 120.311 147.082C119.109 145.731 118.508 144.141 118.508 142.312H120.16C120.16 143.836 120.697 145.134 121.771 146.208C122.845 147.282 124.144 147.819 125.668 147.819C127.191 147.819 128.49 147.282 129.564 146.208C130.638 145.134 131.175 143.836 131.175 142.312H132.827C132.827 144.141 132.226 145.731 131.024 147.082C129.821 148.434 128.311 149.213 126.494 149.421V153.051H124.841Z'
        fill={buttonColor}
      />
    </svg>
  );
}
